import { createClientStorageWithExpiry } from '@superbet-group/web.lib.vue-utilities';

import { logger } from '@app/logger';

export const clientStorageWithExpiry = createClientStorageWithExpiry(logger);
